<template>
    <div class="guest-layout">
        <heading-brand/>
        <main class="container" role="main">
            <slot/>
        </main>
        <footer-component v-if="footer === true"/>
    </div>
</template>

<style scoped>
    .guest-layout {
        display: flex;
        flex-direction: column;
       /* min-height: 100vh;*/
        justify-content: space-between;
        overflow: hidden;
    }
</style>

<script>
import HeadingBrand from "../HeadingBrand"
import FooterComponent from "../FooterComponent"

export default {
    components: {
        HeadingBrand,
        FooterComponent
    },
    props: {
        footer: {
            type: Boolean,
            default: true
        }
    },
}
</script>
